export default {
  title: {
    id: 'design_pickers_carousel_title',
    defaultMessage: 'Select a design',
  },
  alternativeNext: {
    id: 'design_pickers_carousel_next',
    defaultMessage: 'Next',
  },
  alternativePrevious: {
    id: 'design_pickers_carousel_previous',
    defaultMessage: 'Previous',
  },
  selectedDesign: {
    id: 'design_pickers_selected_design_alt',
    defaultMessage: 'Selected design {designType}',
  },
  chooseDesign: {
    id: 'design_pickers_choose_design_alt',
    defaultMessage: 'Choose design {designType}',
  },
}
